import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import tasksListNewTasksSaga from './sagas/tasksListNewTasksSaga';
import tasksToExecutorsSaga from './sagas/tasksToExecutorsSaga';
import tasksListAsOwnerSaga from './sagas/tasksListAsOwnerSaga';
import tasksListChosenTasksSaga from './sagas/tasksListChosenTasksSaga';
import tasksListHideTasksSaga from './sagas/tasksListHideTasksSaga';
import tasksExecsListByAuthUserSaga from './sagas/tasksExecsListByAuthUserSaga';
import tasksExecsListByTaskSaga from './sagas/tasksExecsListByTaskSaga';
import tasksExecsListByTaskOwnerSaga from './sagas/tasksExecsListByTaskOwnerSaga';
import execsListAuthUserByTaskSaga from './sagas/execsListAuthUserByTaskSaga';

export default [
  ...createCombineMapItem('tasksListNewTasks', createListReduceObject, [
    tasksListNewTasksSaga
  ]),
  // tasksToExecutors для замены tasksListNewTasks
  ...createCombineMapItem('tasksToExecutors', createListReduceObject, [
    tasksToExecutorsSaga
  ]),

  ...createCombineMapItem('tasksListAsOwner', createListReduceObject, [
    tasksListAsOwnerSaga
  ]),
  ...createCombineMapItem('tasksListChosenTasks', createListReduceObject, [
    tasksListChosenTasksSaga
  ]),
  ...createCombineMapItem('tasksListHideTasks', createListReduceObject, [
    tasksListHideTasksSaga
  ]),

  ...createCombineMapItem('tasksExecsListByAuthUser', createListReduceObject, [
    tasksExecsListByAuthUserSaga
  ]),
  ...createCombineMapItem('tasksExecsListByTask', createListReduceObject, [
    tasksExecsListByTaskSaga
  ]),
  ...createCombineMapItem('tasksExecsListByTaskOwner', createListReduceObject, [
    tasksExecsListByTaskOwnerSaga
  ]),
  ...createCombineMapItem('execsListAuthUserByTask', createListReduceObject, [
    execsListAuthUserByTaskSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/lists/reducersMap.js